import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { RouteLayoutOptions } from '../models/route.model';

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
  layout: RouteLayoutOptions | undefined;
}

export class RouteSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    const layout = route.data['layout'];

    return { url, params, queryParams, layout };
  }
}
